import { useInfiniteQuery, useMutation } from 'react-query';
import {
  BenefitConsumable,
  BenefitConsumableListRequest,
} from './benefits-consumable.types';
import benefitsConsumableServices from './benefits-consumable.services';
import notificationError from '@/utils/functions/notificationError';
import { queryClient } from '@/Root';

export const QUERY_BENEFIT_CONSUMABLE_LIST_KEY = 'benefit-consumable/list';
export const QUERY_BENEFIT_CONSUMABLE_DETAIL_KEY = 'benefit-consumable-detail';

export function useBenefitConsumableList(
  params?: BenefitConsumableListRequest,
  enabled = true,
) {
  const cache = queryClient.getQueryData([
    QUERY_BENEFIT_CONSUMABLE_LIST_KEY,
    { ...params },
  ]);

  return useInfiniteQuery({
    queryKey: [QUERY_BENEFIT_CONSUMABLE_LIST_KEY, { ...params }],
    queryFn: ({ pageParam }) =>
      benefitsConsumableServices.list({ ...params, nextToken: pageParam }),
    getNextPageParam: (lastPage) => lastPage.nextToken,
    enabled: enabled && !cache,
    onError(err) {
      notificationError(err);
    },
    retry: 0,
  });
}

export function useBenefitConsumableDetailMutation() {
  return useMutation(
    async (consumableId: number) => {
      const cache = queryClient.getQueryData<BenefitConsumable>([
        QUERY_BENEFIT_CONSUMABLE_DETAIL_KEY,
        consumableId,
      ]);
      if (!!cache) return cache;

      return await benefitsConsumableServices.detail(consumableId);
    },
    {
      onError(err) {
        notificationError(err);
      },
      onSuccess(data, consumableId) {
        queryClient.setQueryData(
          [QUERY_BENEFIT_CONSUMABLE_DETAIL_KEY, consumableId],
          data,
        );
      },
      retry: 0,
    },
  );
}
